import { render, staticRenderFns } from "./DepartModalNew.vue?vue&type=template&id=b8fc4032&"
import script from "./DepartModalNew.vue?vue&type=script&lang=js&"
export * from "./DepartModalNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports